import type { DesignTokens } from '@vibesites/tokens';
import { defaultTokens } from '@vibesites/tokens';

export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    primary: '#B28C59',
    secondary: '#3E441D',
    accent: '#FFF1DA',
    background: '#FFFFFF',
    surface: '#F5F3EF',
    text: '#342E1F',
    textMuted: '#6B6355',
    textOnPrimary: '#FFFFFF',
    textOnSecondary: '#FFFFFF',
    border: '#E2DDD5',
    error: '#dc2626',
    success: '#16a34a',
    warning: '#f59e0b',
  },
  font: {
    ...defaultTokens.font,
    heading: '"Rubik", sans-serif',
    body: '"Rubik", sans-serif',
  },
  fontSize: {
    ...defaultTokens.fontSize,
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    '4xl': '2.5rem',
    '5xl': '3rem',
  },
  fontWeight: {
    ...defaultTokens.fontWeight,
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
  spacing: {
    ...defaultTokens.spacing,
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
  },
  radius: {
    ...defaultTokens.radius,
    sm: '0.125rem',
    md: '0.25rem',
    lg: '0.5rem',
    full: '9999px',
  },
  shadow: {
    ...defaultTokens.shadow,
    sm: '0 1px 2px rgba(52, 46, 31, 0.05)',
    md: '0 4px 6px rgba(52, 46, 31, 0.07)',
    lg: '0 10px 15px rgba(52, 46, 31, 0.1)',
  },
  transition: {
    ...defaultTokens.transition,
    fast: '150ms ease',
    normal: '300ms ease',
    slow: '500ms ease',
  },
};

export default tokens;
